import { render, staticRenderFns } from "./Topbar.vue?vue&type=template&id=21567596&"
import script from "./Topbar.vue?vue&type=script&lang=js&"
export * from "./Topbar.vue?vue&type=script&lang=js&"
import style0 from "./Topbar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21567596')) {
      api.createRecord('21567596', component.options)
    } else {
      api.reload('21567596', component.options)
    }
    module.hot.accept("./Topbar.vue?vue&type=template&id=21567596&", function () {
      api.rerender('21567596', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "auth_ui/static/vue-src/components/Topbar.vue"
export default component.exports